require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-qk-curriculum-portal.json") })
        }
      }, "path---learning-qk-curriculum-portal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-qk-curriculum-portal!./.cache/json/learning-qk-curriculum-portal.json
// module id = 1244
// module chunks = 231608221292675